import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const AddCompanyHistory = () => {
  const [companyName, setCompanyName] = useState('');
  const [ceo, setCeo] = useState('');
  const [coo, setCoo] = useState('');
  const [cto, setCto] = useState('');
  const [history, setHistory] = useState('');
  const [ceoImage, setCeoImage] = useState(null);
  const [cooImage, setCooImage] = useState(null);
  const [ctoImage, setCtoImage] = useState(null);
  const navigate = useNavigate();

  // Handle file input for CEO profile image
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setCeoImage(reader.result);
      setCooImage(reader.result);
      setCtoImage(reader.result); // Store Base64 encoded image
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Save the company history including CEO image
    const companyDetails = {
      name: companyName,
      ceo: ceo,
      coo: coo,
      cto: cto,
      ceoImage,
      cooImage,
      ctoImage,
      history, // Include the Base64 image string
    };

    // Store in local storage or state management
    localStorage.setItem('companyDetails', JSON.stringify(companyDetails));

    // Navigate to company details page
    navigate('/company-details');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <SEO
        title="Add Company History"
        description="Add your production company's history and milestones to your ProducerBuddy profile."
        url="https://producerbuddy.pilomation.com/add-company-history"
        robots="noindex, nofollow"
      />
      <h1 className="text-4xl font-bold text-center mb-6">Add Company History</h1>
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-md">
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="companyName">
            Company Name
          </label>
          <input
            type="text"
            id="companyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="ceo">
            CEO
          </label>
          <input
            type="text"
            id="ceo"
            value={ceo}
            onChange={(e) => setCeo(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="ceoImage">
            CEO Profile Image
          </label>
          <input
            type="file"
            id="ceoImage"
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="coo">
            COO
          </label>
          <input
            type="text"
            id="coo"
            value={coo}
            onChange={(e) => setCoo(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="cooImage">
            COO Profile Image
          </label>
          <input
            type="file"
            id="cooImage"
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="cto">
            CTO
          </label>
          <input
            type="text"
            id="cto"
            value={cto}
            onChange={(e) => setCto(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="ctoImage">
            CTO Profile Image
          </label>
          <input
            type="file"
            id="ctoImage"
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="history">
            Company History
          </label>
          <textarea
            id="history"
            value={history}
            onChange={(e) => setHistory(e.target.value)}
            required
            rows="4"
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddCompanyHistory;

